const menuNullCheck = document.getElementById("menu-toggle-open");

if (menuNullCheck !== null) {
	// menu toggle
	document.getElementById("menu-toggle-open").addEventListener("click", (e) => {
		$("body").addClass("scroll_none");
		// $("#menu-toggle-open").css("display", "none");
		$("#menu-toggle-open").css("visibility", "hidden");
		$("#menu-cont").attr("style", "visibility: visible;");
		// $("#menu-cont").attr("data-open", "true");
		$("#menu-cont").css("display", "flex");
		$("#menu-toggle-close").css("display", "inline-block");
	});

	document
		.getElementById("menu-toggle-close")
		.addEventListener("click", (e) => {
			$("body").removeClass("scroll_none");
			$("#menu-toggle-close").css("display", "none");
			$("#menu-toggle-open").css("visibility", "visible");
			$("#menu-cont").attr("style", "visibility: hidden;");
			// $("#menu-cont").attr("data-open", "false");
			$("#menu-toggle-open").css("display", "inline-block");
			$("#menu-cont").css("display", "none");
		});
}

// klaviyo subscriber form
$("#k_id_email").on("input", function (e) {
	$(".email_error").addClass("none");
	$("#klaviyo_nav_signup").removeClass("form_error_bb");
});
$("#k_id_blog_email").on("input", function (e) {
	$("#k_id_blog_email > .email_error").addClass("none");
	$("#k_id_blog_email").removeClass("form_error_bb");
});
$("#k_id_phone").on("input", function (e) {
	$(".phone_error").addClass("none");
	$("#k_id_phone").removeClass("form_error_bb");
});

$("#password_entry").on("focus input", function (e) {
	$("#password_entry").removeClass("form_error_bb");
});

$("#nav_email_signup").on("submit", function (e) {
	e.preventDefault();
	const email = $("#k_id_email").val();
	let eReg = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(email);

	if (eReg !== true) {
		$(".email_error").removeClass("none");
		$("#klaviyo_nav_signup").addClass("form_error_bb");
		throw new Error("Invalid Email Entry");
	}

	const formId = $('input[name="g"]').val().replace(/'/g, "");
	$.ajax({
		async: true,
		crossDomain: true,
		type: "POST",
		headers: {
			"content-type": "application/x-www-form-urlencoded",
			"cache-control": "no-cache",
		},
		url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
		data: {
			g: formId,
			$fields: "$source",
			email: email,
			$source: "Menu Navigation",
			$method_type: "Klaviyo Form",
			$method_id: "embed",
			$consent_version: "Embed default text",
		},
	})
		.done(function (response) {
			console.log(response);
			$("#nav_email_signup .klaviyo_field_group input[type=submit]").prop(
				"disabled",
				true
			);
			$(".klaviyo_field_group").addClass("none");
			$(".success_message").removeClass("none");
			setTimeout(() => {
				$(".success_message").remove();
			}, 3000);
		})
		.fail(function (xhr, textStatus, errorThrown) {
			// error
			$(".email_error").removeClass("none");
			$("#klaviyo_nav_signup").addClass("form_error_bb");
			// $(".error_message").removeClass("none");
			// setTimeout(() => {
			// 	$(".error_message").remove();
			// }, 3000);
		});
});

$("body").addClass("scroll_none");
$("body").addClass("nav-open");
$("body").removeClass("scroll_none");
$("body").removeClass("nav-open");
// $(window).scroll(function (event) {
// 	const scrollPosition = $(document).scrollTop();
// });
